/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};
//
// 检测商户名称是否存在
exports.existServicerName = function (data, callback) {// 根据name验证
    api.post('/servicer/name/exist')
    .data(data)
    .done(callback)
    .go();
};
exports.applyServicer = function (params, callback) {// 申请服务商信息
    api.post('/servicer/apply/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.reApplyServicer = function (params, callback) {// 再次申请服务商
    api.post('/servicer/reApply/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//回显数据
exports.getServicerInfoByAdminId = function (params, callback) {// 根据管理员ID获取再次申请的商户和资质信息
    api.post('/servicer/info/get/by/adminId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerListByUserId = function (params, callback) {// 根据userId查询
    api.post('/servicer/list/get/by/userId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerCheckResult = function (data, done, fail) {// 验证服务商
    api.post('/servicer/check/result/get')
    .data(data)
    .done(done)
    .fail(fail || done)
    .go();
};
exports.getServicer = function (data, callback) {// 获取服务商
    api.post('/servicer/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取当前商户  佣金是否足额
exports.getServicerYjFeeSuffient = function (params, callback) {
    api.get('/servicer/yjFeeSuffient/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerMailboxList = function (params, callback) {// 获取邮箱列表
    api.post('/servicer/mailbox/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveServicerMailbox = function (params, callback) {// 保存邮箱
    api.post('/servicer/mailbox/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateServicerMailbox = function (params, callback) {// 更新邮箱
    api.post('/servicer/mailbox/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerMailbox = function (params, callback) {// 查询邮箱
    api.post('/servicer/mailbox/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateServicerMailboxDefalut = function (params, callback) {// 设置为默认邮箱
    api.post('/servicer/mailbox/update/default/do')
    .params(params)
    .done(callback)
    .go();
};

exports.deleteServicerMailbox = function (params, callback) {// 删除邮箱
    api.post('/servicer/mailbox/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerPubAgreementList = function (data, callback) {// 获取公共协议分页列表
    api.post('/servicer/pub/agreement/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveServicerPubAgreement = function (data, callback) {// 保存公共协议
    api.post('/servicer/pub/agreement/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateServicerPubAgreement = function (data, callback) {// 更新公共协议
    api.post('/servicer/pub/agreement/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteServicerPubAgreement = function (data, callback) {// 删除公共协议
    api.post('/servicer/pub/agreement/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//===============服务商公司业务地址==========
exports.getServicerAddrPagedList = function (data, callback) {// 获取服务商公司地址列表
    api.post('/servicer/addr/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServicerAddr = function (data, callback) {// 获取公司业务地址
    api.post('/servicer/addr/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveServicerAddr = function (data, callback) {// 保存/修改公司业务地址
    api.post('/servicer/addr/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.deleteServicerAddr = function (data, callback) {// 删除服务商公司地址
    api.post('/servicer/addr/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//设置默认发货
exports.updateServicerSendAddrDefault = function (data, callback) {// 设置发货默认地址
    api.post('/servicer/send/addr/default/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//设置默认收货
exports.updateServicerRevcAddrDefault = function (data, callback) {// 设置收货默认地址
    api.post('/servicer/revc/addr/default/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//设置收货
exports.setServicerRevcAddr = function (data, callback) {// 设置收货地址
    api.post('/servicer/revc/addr/set/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//设置发货
exports.updateServicerSendAddr = function (data, callback) {// 设置发货地址
    api.post('/servicer/send/addr/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//服务商列表
exports.getServicerList = function (data, callback) {// 获取服务商列表
    api.post('/servicer/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//服务商列表
exports.getServicerInfo = function (params, callback) {// 获取服务商信息
    api.get('/servicer/info/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getServicerOrgComList = function (data, callback) {// 获取服务商公司信息
    api.post('/servicer/org/com/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取公司列表 -- TODO
exports.getServicerComList = function (params, callback) {// 获取服务商公司信息
    api.post('/servicer/com/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 获取公司列表
exports.getServicerComListByMerchantId = function (params, callback) {// 获取服务商公司信息
    api.post('/servicer/list/get/by/merchantId')
    .data(params)
    .done(callback)
    .go();
};

// 根据父id获取公司列表
exports.getServicerComListByParentId = function (params, callback) {
    api.post('/servicer/com/list/get/by/parentId')
    .data(params)
    .done(callback)
    .go();
};
exports.getServicerComListByContext = function (data, callback) {
    api.post('/servicer/com/list/get/by/context')
    .data(data)
    .done(callback)
    .go();
};

// 根据id获取公司信息
exports.getServicerCom = function (data, callback) {// 获取服务商公司信息
    api.post('/servicer/com/get')
    .sync()
    .data(data)
    .done(callback)
    .go();
};

exports.saveServicerCom = function (data, callback) {// 保存服务商公司
    api.post('/servicer/com/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateServicerComFailover = function (data, callback) {// 保存服务商公司
    api.post('/servicer/com/failover/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateServicerCom = function (data, callback) {// 更新服务商
    api.post('/servicer/com/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateServicerComParams = function (data, callback) {// 服务网点参数设置
    api.post('/servicer/com/update/for/params/do')
    .data(data)
    .done(callback)
    .go();
};
exports.moveServicerComSeq = function (data, callback) {// 上下移条目
    api.post('/servicer/com/seq/move/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerComListByUserId = function (params, callback) {// 根据userId查询服务商门店信息
    api.get('/servicer/com/list/get/by/userId')
    .params(params)
    .done(callback)
    .go();
};

// 获取公司人员列表
exports.getServicerStaffList = function (params, callback) {// 获取服务商人员列表
    api.post('/servicer/staff/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getComForExport = function (params, callback) {// 上下移条目
    api.post('/servicer/com/export/do')
    .data(params)
    .done(callback)
    .go();
};

// 获取公司人员列表--暂用于 发送站内信
exports.getServicerStaffListForMsg = function (params, callback) {
    api.post('/servicer/staff/list/get/for/msg')
    .data(params)
    .done(callback)
    .go();
};
// 获取 当前公司及下级公司 的人员列表
exports.getServicerStaffListForBizMsg = function (data, callback) {
    api.post('/servicer/staff/list/get/for/biz/msg')
    .data(data)
    .done(callback)
    .go();
};

// 获取当前公司的管理员
exports.getServicerChildComAdmin = function (params, callback) {// 获取子公司的管理员
    api.get('/servicer/child/com/admin/get')
    .params(params)
    .done(callback)
    .go();
};
// 根据手机号码校验人员信息
exports.checkStaffInfoByPhoneNo = function (params, callback) {// 根据手机号码校验人员信息
    api.get('/servicer/check/staff/by/phoneNo')
    .params(params)
    .done(callback)
    .go();
};
// 保存公司人员
exports.saveServicerStaff = function (params, callback) {// 保存服务商人员
    api.post('/servicer/staff/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 批量导入公司人员
exports.saveServicerStaffList = function (data, callback) {
    api.post('/servicer/staff/list/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取岗位关联的人员列表
exports.getComRoleRefStaffList = function (params, callback) {
    api.post('/servicer/com/role/ref/staff/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 获取公司人员信息
exports.getServicerStaff = function (params, callback) {
    api.get('/servicer/staff/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 获取公司人员信息
exports.getServicerStaffInfoByComIdAndUserId = function (params, callback) {
    api.get('/servicer/staff/info/get/by/comId/and/userId')
    .params(params)
    .done(callback)
    .go();
};

// 更新公司人员
exports.updateServicerStaff = function (params, callback) {// 更新服务商人员
    api.post('/servicer/staff/update/do')
    .data(params)
    .done(callback)
    .go();
};

// 离职
exports.updateRetailerStaffForQuitFlag = function (data, callback) {// 更新服务商人员
    api.post('/servicer/staff/quitFlag/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doServicerShopClose = function (data, callback) {// 闭店处理
    api.post('/servicer/com/closed/update')
    .data(data)
    .done(callback)
    .go();
};

// 选择公司人员列表
exports.getServicerStaffsForSelected = function (params, callback) {// 获取服务商人员选择列表
    api.post('/servicer/staff/list/get/for/selected')
    .data(params)
    .done(callback)
    .go();
};
// 检查是否存在其他商户
exports.existOtherMercht = function (params, callback) {// 检查是否存在其他商户
    api.post('/servicer/exist/other/mercht')
    .data(params)
    .done(callback)
    .go();
};
exports.existDiffStaffName = function (params, callback) {// 检查当前手机号是否已有不同员工姓名
    api.post('/servicer/exist/diff/staffName')
    .data(params)
    .done(callback)
    .go();
};
exports.existStaffNameInfo = function (params, callback) {// 检查当前手机号码在当前商户是否存在同名员工
    api.get('/servicer/exist/same/staffName')
    .params(params)
    .done(callback)
    .go();
};

// 指定管理员
exports.specifyServicerChildComAdmin = function (params, callback) {// 指定子公司的管理员
    api.post('/servicer/child/com/admin/specify/do')
    .data(params)
    .done(callback)
    .go();
};

// 商户工程师列表
exports.getServicerXngineerPageList = function (params, callback) {
    api.post('/servicer/xngineer/page/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 手工新增商户工程师
exports.saveServicerXngineer = function (params, callback) {
    api.post('/servicer/xngineer/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 选择商户员工新增商户级别工程师
exports.saveServicerXngineerForMercht = function (params, callback) {
    api.post('/servicer/xngineer/save/by/mercht/staff/do')
    .data(params)
    .done(callback)
    .go();
};
// 编辑商户级别工程师
exports.upateServicerXngineer = function (params, callback) {
    api.post('/servicer/xngineer/update/do')
    .data(params)
    .done(callback)
    .go();
};
// 删除商户级别工程师
exports.deleteServicerXngineer = function (params, callback) {
    api.post('/servicer/xngineer/delete/do')
    .data(params)
    .done(callback)
    .go();
};
// 商户工程师分配网点
exports.saveServicerEngineerForXngineer = function (params, callback) {
    api.post('/servicer/xngineer/save/for/engineer/do')
    .data(params)
    .done(callback)
    .go();
};

// 同步所有下级网点工程师
exports.syncComEngineerListMsg = function (params, callback) {
    api.post('/servicer/xngineer/com/engineer/sync/do')
    .data(params)
    .done(callback)
    .go();
}

//服务商工程师列表
exports.getServicerEngineerListByComId = function (params, callback) {// 获取服务商工程师列表（不带分页）
    api.post('/servicer/engineer/list/get/by/comId')
    .data(params)
    .done(callback)
    .go();
};
exports.getServicerEngineerPageByComId = function (params, callback) {// 获取服务商工程师列表
    api.post('/servicer/engineer/page/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getServicerEngineerListForSelected = function (params, callback) {// 获取服务商工程师列表（选择列表）
    api.post('/servicer/engineer/list/get/for/selected')
    .data(params)
    .done(callback)
    .go();
};
exports.getServicerEngineer = function (params, callback) {// 获取服务商工程师
    api.post('/servicer/engineer/get')
    .data(params)
    .done(callback)
    .go();
};
// 网点工程师列表
exports.getServicerEngineersForShop = function (params, callback) {
    api.post('/servicer/engineer/list/get/for/shop')
    .data(params)
    .done(callback)
    .go();
};

exports.saveServicerEngineer = function (params, callback) {// 保存服务商工程师
    api.post('/servicer/engineer/save/do')
    .data(params)
    .done(callback)
    .go();
};
exports.deleteServicerEngineer = function (params, callback) {// 删除服务商工程师
    api.post('/servicer/engineer/delete/do')
    .data(params)
    .done(callback)
    .go();
};
exports.updateServicerEngineer = function (params, callback) {// 修改服务商工程师
    api.post('/servicer/engineer/update/do')
    .data(params)
    .done(callback)
    .go();
};
exports.updateEngineerServc = function (params, callback) {// 编辑工程师服务能力
    api.post('/servicer/engineer/servc/update/do')
    .data(params)
    .done(callback)
    .go();
};
exports.updateEngineerServcsForCopy = function (data, callback) {// 复制工程师服务能力
    api.post('/servicer/engineer/servc/update/for/copy/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getEngineerServcList = function (params, callback) {// 获取工程师服务能力
    api.post('/servicer/engineer/servc/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getServicerEngineerWorkStateCountByComId = function (params, callback) {// 获取工程师状态的数量
    api.get('/servicer/engineer/workState/count/get/comId')
    .params(params)
    .done(callback)
    .go();
};

exports.getEngineerIdsByServcIdForMercht = function (params, callback) {// 根据服务id获取工程师ids
    api.get('/servicer/engineerIds/get/by/servcId/for/mercht')
    .params(params)
    .done(callback)
    .go();
};
exports.getEngineerIdsByServcId = function (params, callback) {// 根据服务id获取工程师ids
    api.get('/servicer/engineerIds/get/by/servcId')
    .params(params)
    .done(callback)
    .go();
};
exports.getServicerStaffListByComId = function (data, callback) {// 获取该公司的员工信息
    api.post('/servicer/staff/list/get/by/comId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcLastEngineerByUk = function (data, callback) {// 根据唯一键获取服务最近工程师信息
    api.post('/servicer/servc/last/engineer/get/by/Uk')
    .data(data)
    .done(callback)
    .go();
};

exports.getServcLastEngineerList = function (data, callback) {// 根据服务最近工程师列表
    api.post('/servicer/servc/last/engineer/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getServcLastEngineerGoodsCatList = function (data, callback) {// 根据服务最近工程师列表
    api.post('/servicer/servc/last/engineer/cat/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getServcDeftEngineerList = function (data, callback) {// 工程师维度-查看默认工程师列表
    api.post('/servicer/servc/deft/engineer/list/get/for/engineer')
    .data(data)
    .done(callback)
    .go();
};

exports.getServcDeftEngineers = function (data, callback) {// 获取服务默认工程师列表
    api.post('/servicer/servc/deft/engineer/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getServcDeftEngineerByUk = function (data, callback) {// 根据唯一键获取服务默认工程师信息
    api.post('/servicer/servc/deft/engineer/get/by/Uk')
    .data(data)
    .done(callback)
    .go();
};

exports.getServcDeftEngineerIdByFilter = function (data, callback) {
    api.post('/servicer/servc/deft/engineerIds/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getServcDeftEngineerIdByUk = function (data, callback) {// 根据唯一键获取服务默认工程师的工程师id
    api.post('/servicer/servc/deft/engineerId/get/by/Uk')
    .data(data)
    .done(callback)
    .go();
};
exports.getServcDeftEngineerCountByEngineerId = function (params, callback) {// 根据唯一键获取服务默认工程师的工程师id
    api.get('/servicer/servc/deft/engineer/count/get/by/engineerId')
    .params(params)
    .done(callback)
    .go();
};

exports.saveServcDeftEngineer = function (data, callback) {// 保存服务默认工程师
    api.post('/servicer/servc/deft/engineer/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteServcDeftEngineer = function (params, callback) {// 删除服务默认工程师
    api.post('/servicer/servc/deft/engineer/delete/do')
    .params(params)
    .done(callback)
    .go();
};

// 服务商业务日志列表
exports.getServcerBizLogList = function (postData, callback) {// 获取服务商业务日志列表
    api.post('/servicer/biz/log/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 服务商业务日志详细信息
exports.getServcerBizLog = function (postData, callback) {// 获取服务商业务日志
    api.get('/servicer/biz/log/get')
    .params(postData)
    .done(callback)
    .go();
};
// 更改站点信接收者
exports.doSpecifyOperatorComReceiver = function (postData, callback) {
    api.post('/servicer/com/receiver/specify/do')
    .data(postData)
    .done(callback)
    .go();
};

//保存公司域名信息
exports.saveDoMainName = function (postData, callback) {// 保存公司域名信息
    api.post('/servicer/domain/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// --------------- 服务转单原因 -----------------
exports.getServcWorkTransCause = function (params, callback) {// 获取服务转单原因
    api.get('/servicer/servc/work/trans/cause/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getServcWorkTransCauseList = function (data, callback) {// 获取服务转单原因列表
    api.post('/servicer/servc/work/trans/cause/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveServcWorkTransCause = function (data, callback) {// 保存服务转单原因
    api.post('/servicer/servc/work/trans/cause/save')
    .data(data)
    .done(callback)
    .go();
};

exports.setServcWorkTransCauseDisable = function (data, callback) {// 服务转单原因  启、禁用
    api.post('/servicer/servc/work/trans/cause/disable')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteServcWorkTransCause = function (params, callback) {// 删除 服务转单原因
    api.post('/servicer/servc/work/trans/cause/delete')
    .params(params)
    .done(callback)
    .go();
};

// ------------------- 服务调度消息订阅 ---------------

exports.getWorkSchedMsgSubscrPageList = function (data, callback) {// 根据staffId 获取 服务调度消息订阅 分页列表
    api.post('/servicer/work/sched/msg/subscr/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveWorkSchedMsgSubscr = function (data, callback) {// 根据staffId 获取 服务调度消息订阅 分页列表
    api.post('/servicer/work/sched/msg/subscr/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getCatIdsByStaffIdAndServicerShopId = function (data, callback) {// 根据staffId 获取 服务调度消息订阅 的 goodsCatIds
    api.post('/servicer/work/sched/msg/subscr/catIds/get')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteMsgSubSrc = function (params, callback) {// 取消订阅
    api.post('/servicer/work/sched/msg/subscr/delete/do')
    .params(params)
    .done(callback)
    .go();
};

exports.deleteMsgSubSrcByUk = function (data, callback) {// 分类里 取消订阅 - 用唯一键
    api.post('/servicer/work/sched/msg/subscr/delete/do/by/UK')
    .data(data)
    .done(callback)
    .go();
};

exports.saveServicerComBatch = function (data, callback) {// 获取零售商公司信息
    api.post('/servicer/com/batch/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteServicerCom = function (data, callback) {// 删除零售商机构
    api.post('/servicer/com/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerUserList = function (data, callback) {// 获取服务商人员列表(user)
    api.post('/servicer/user/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerStaffByUserIdAndComId = function (data, callback) {// 获取服务商员工信息根据
    api.get('/servicer/staff/info/get/by/uk')
    .params(data)
    .done(callback)
    .go();
};

// ----------- 服务网点服务能力列表 -------------
exports.getServcDevcCatRelPageList = function (data, callback) {// 获取服务商工程师列表（不带分页）
    api.post('/servicer/servc/devcCat/Rel/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.deleteServcDevcCatRel = function (params, callback) {
    api.post('/servicer/servc/devcCat/Rel/delete/do')
    .params(params)
    .done(callback)
    .go();
};

// 服务级别 - 设置服务工程师服务能力
exports.saveEngineerServcList = function (data, callback) {
    api.post('/servicer/engineer/servc/list/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.saveXngineerServcList = function (data, callback) {
    api.post('/servicer/xngineer/servc/list/save/do')
    .data(data)
    .done(callback)
    .go();
};
//  服务级别 - 查看服务工程师服务能力
exports.getEngineerServcListForServc = function (data, callback) {
    api.post('/servicer/engineer/servc/list/get/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getXngineerServcListForServc = function (data, callback) {
    api.post('/servicer/xngineer/servc/list/get/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateServicerComContacts = function (data, callback) {// 同步机构联系方式
    api.post('/servicer/com/contacts/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateServicerComForJointId = function (data, callback) {// 同步机构联系方式
    api.post('/servicer/com/jointId/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getServicerNoticeList = function (data, callback) {// 零售商统一设置权限开启
    api.post('/servicer/notice/list/page')
    .data(data)
    .done(callback)
    .go();
};
exports.getSubServicerComRole = function (data, callback) {// 零售商统一设置权限开启
    api.post('/servicer/com/role/list/page')
    .data(data)
    .done(callback)
    .go();
};
exports.saveServicerNotice = function (data, callback) {// 零售商统一设置权限开启
    api.post('/servicer/notice/save')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerNotice = function (params, callback) {// 零售商统一设置权限开启
    api.get('/servicer/notice/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
exports.deleteServicerNotice = function (params, callback) {// 零售商统一设置权限开启
    api.post('/servicer/notice/delete')
    .data(params)
    .done(callback)
    .go();
};
exports.sendServicerNotice = function (params, callback) {// 零售商统一设置权限开启
    api.post('/servicer/notice/send')
    .data(params)
    .done(callback)
    .go();
};
exports.getServicerComRoleListBySrcTblIds = function (data, callback) {// 零售商统一设置权限开启
    api.post('/servicer/com/role/get/by/src/tbl/ids')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerXstaffList = function (data, callback) {// 服务商人员列表
    api.post('/servicer/xstaff/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerXstaff = function (params, callback) {// 服务商人员
    api.get('/servicer/xstaff/get')
    .params(params)
    .done(callback)
    .go();
};
exports.saveServicerXStaff = function (data, callback) {// 保存服务商人员
    api.post('/servicer/xstaff/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateServicerXstaffDisabled = function (data, callback) {// 商户人员启禁用
    api.post('/servicer/xstaff/disabled/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerXstaffUserIds = function (data, callback) {// 服务商人员UserIds
    api.post('/servicer/xstaff/userId/list/get')
    .data(data)
    .done(callback)
    .go();
};

// ======================== 个人收藏 ===============================

// 个人收藏列表
exports.getServicerStaffFavoriteCachedList = function (data, callback) {// 个人收藏列表
    api.post('/servicer/staff/favorite/cached/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 保存个人收藏
exports.saveServicerStaffFavorite = function (data, callback) {// 保存个人收藏
    api.post('/servicer/staff/favorite/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 移除个人收藏
exports.deleteServicerStaffFavorite = function (data, callback) {// 移除个人收藏
    api.post('/servicer/staff/favorite/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ========================== 查询配置 ===============================
// 查询元设结果配置信息 + 结果配置
exports.getQryResultMetaConf = function (params, callback) {
    api.get('/servicer/meta/query/result/get/by/code')
    .params(params)
    .done(callback)
    .go();
};

// 查询元设查询配置信息
exports.getMetaQueryConf = function (params, callback) {
    api.get('/servicer/meta/query/conf/get/by/code')
    .params(params)
    .done(callback)
    .go();
};
// 查询个性化查询配置-根据code
exports.getCustQueryConf = function (params, callback) {
    api.get('/servicer/cust/query/conf/get/by/code')
    .params(params)
    .done(callback)
    .go();
};

// 保存-个性化查询配置
exports.saveCustQueryConf = function (data, callback) {
    api.post('/servicer/cust/query/conf/save/do')
    .data(data)
    .done(callback)
    .go();
};

// ========================== 结果配置 ===============================
// 查询元设结果配置信息
exports.getMetaResultConf = function (params, callback) {
    api.get('/servicer/meta/result/conf/get/by/code')
    .params(params)
    .done(callback)
    .go();
};
// 查询个性化结果配置
exports.getCustResultConf = function (params, callback) {
    api.get('/servicer/cust/result/conf/get/by/code')
    .params(params)
    .done(callback)
    .go();
};
// 保存-个性化结果配置
exports.saveCustResultConf = function (data, callback) {
    api.post('/servicer/cust/result/conf/save/do')
    .data(data)
    .done(callback)
    .go();
};

// ========================= 业务标签管理 =========================

// 获取业务标签列表
exports.getBizTagPagedList = function (data, callback) {
    api.post('/servicer/biz/tag/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取业务标签列表
exports.getBizTagList = function (data, callback) {
    api.post('/servicer/biz/tags/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getBizTagListByBizAspect = function (filter, callback) {
    let data = {};
    data.filterItems = filter;
    exports.getBizTagList(data, callback);
};
// 根据id获取业务标签
exports.getBizTagById = function (params, callback) {
    api.get('/servicer/biz/tag/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
// 保存业务标签
exports.saveBizTag = function (data, callback) {
    api.post('/servicer/biz/tag/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 启禁用业务标签
exports.updateBizTagDisabledState = function (data, callback) {
    api.post('/servicer/biz/tag/disabled/state/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除业务标签
exports.deleteBizTag = function (data, callback) {
    api.post('/servicer/biz/tag/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ========================= 附件标签管理 =========================

// 获取附件标签列表
exports.getAttTagPagedList = function (data, callback) {
    api.post('/servicer/att/tag/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取附件标签列表
exports.getAttTagList = function (data, callback) {
    api.post('/servicer/att/tags/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getAttTagListByAttAspect = function (filter, callback) {
    let data = {};
    data.filterItems = filter;
    exports.getAttTagList(data, callback);
};
// 根据id获取附件标签
exports.getAttTagById = function (params, callback) {
    api.get('/servicer/att/tag/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
// 保存附件标签
exports.saveAttTag = function (data, callback) {
    api.post('/servicer/att/tag/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 启禁用附件标签
exports.updateAttTagDisabledState = function (data, callback) {
    api.post('/servicer/att/tag/disabled/state/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除附件标签
exports.deleteAttTag = function (data, callback) {
    api.post('/servicer/att/tag/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ======================== 授权服务商管理 ==================
exports.getAuthServicerInfo = function (params, callback) {
    api.get('/servicer/auth/servicer/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 授权服务商 - 列表
exports.getAuthServicerPageLislt = function (data, callback) {
    api.post('/servicer/auth/servicer/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 更具服务商查询对应的授权信息
exports.getAuthServicerInfoByServicerId = function (params, callback) {
    api.get('/servicer/auth/servicer/info/get/by/servierId')
    .params(params)
    .done(callback)
    .go();
};
exports.saveAuthServicer = function (data, callback) {
    api.post('/servicer/auth/servicer/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateAuthServicer = function (data, callback) {
    api.post('/servicer/auth/servicer/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateAuthServicerForRevoked = function (data, callback) {
    api.post('/servicer/auth/servicer/update/revoked/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getRealComTreeList = function (params, callback) {
    api.post('/servicer/real/com/tree/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getServicerXngineerList = function (params, callback) {
    api.post('/servicer/xngineer/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.doDisbaledServcDevcCatRel = function (params, callback) {
    api.post('/servicer/servc/devcCat/rel/disabled/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServicerXngineer = function (params, callback) {
    api.get('/servicer/xngineer/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDeleteEngineerServc = function (params, callback) {
    api.post('/servicer/engineer/servc/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servicer.js
// module id = 6
// module chunks = 1